import { createContext } from "react";
var PusherContext = /*#__PURE__*/createContext({
  pusher: undefined,
  connected: false,
  myActiveChannels: [],
  presenceSubscriptionSucceeded: false,
  onlineUsersCount: 0,
  onlineUsersIds: []
});
export default PusherContext;